export default {
	path: '/ai-distinguish',
	redirect: '/ai-distinguish',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'aiDistinguishHome',
			component: () => import('@/views/biz/aiDistinguish'),
		},
	],
};
